export const OptionWrapper = ({ children, selected, error, as = "button", onClick }) => {
  const className = `
    w-full py-2 px-4 text-left border transition-all duration-150
    ${selected ? "border-primary bg-warning-subtle" : "border-border bg-background-surface hover:border-border-strong"}
    ${error ? "border-error" : ""}
  `;

  if (as === "div") {
    return <div className={className}>{children}</div>;
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      {children}
    </button>
  );
};
